<!-- Created by Alex Poh. on 12/03/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div class="light-theme">
  <router-outlet class="router-outlet router-flex"></router-outlet>
</div>
